import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { Daisy } from "./Daisy";

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  const onProduct = useLocation().pathname.startsWith("/produkt/");
  useEffect(() => {
    const f = () => setShow(window.scrollY > 600);
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.button
          data-testid="back-to-top-btn"
          aria-label="Zpět nahoru"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          initial={{ opacity: 0, scale: 0.4, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.4, y: 30 }}
          whileHover={{ y: -4 }}
          whileTap={{ scale: 0.85 }}
          transition={{ type: "spring", stiffness: 260, damping: 18 }}
          className={`group fixed ${onProduct ? "bottom-24 md:bottom-8" : "bottom-5 sm:bottom-8"} right-4 z-[45] grid h-12 w-12 place-items-center rounded-full border-[3px] border-white bg-[#A3AC86] shadow-[0_12px_28px_-10px_rgba(45,52,38,.6)] sm:right-8 sm:h-14 sm:w-14`}
        >
          <span className="transition-transform duration-700 group-hover:rotate-180"><Daisy size={34} /></span>
          <span className="absolute -top-2 grid h-5 w-5 place-items-center rounded-full bg-[#7A8460] text-white shadow"><ArrowUp className="h-3 w-3" /></span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
